import { render } from "./InventoryLogsPage.vue?vue&type=template&id=9a7e47d0&scoped=true"
import script from "./InventoryLogsPage.vue?vue&type=script&lang=js"
export * from "./InventoryLogsPage.vue?vue&type=script&lang=js"

import "./InventoryLogsPage.vue?vue&type=style&index=0&id=9a7e47d0&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7e47d0"]])

export default __exports__